import { render, staticRenderFns } from "./FeatureProduct.vue?vue&type=template&id=49521132&"
import script from "./FeatureProduct.vue?vue&type=script&lang=js&"
export * from "./FeatureProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports